<template>
    <div id="calculator_component"
         class="calculator-componet">
        <b-row>
            <b-col class="calculator-header"
                   lg="8">
                <h3>Check how many FTOs will you have at this minute<br class="desktop-only"> if you buy chosen mining package: </h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4">
                <div class="form-item form-item-select" :class="{ 'field-error': errors.has('country') }">
                    <div class="select-outer">
                        <input type="text"
                               name="calculator_package"
                               v-model="selected"
                               @focus="openList = true"
                               @blur="openList = hoverList ? true : false"
                               :readonly="true">
                        <ul v-show="openList">
                            <li v-for="(force, amount) in packages"
                                :key="amount"
                                @click="setItem('FND ' + amount + ' - ' + force + ' FORCE FACTOR', force), openList = false"
                                @mouseover="hoverList = true"
                                @mouseleave="hoverList = false">FND {{ amount }} - {{ force }} FORCE FACTOR</li>
                        </ul>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <p style="margin-bottom: 12px">at this moment you will have (per minute): </p>
            </b-col>
            <b-col cols="4">
                <div class="form-item form-item-amount"
                     v-if="!progress">
                    <div class="transfer-value">
                        <input  name="calculator_fto"
                                type="text"
                                v-model="ftoValue"
                                :readonly="true">
                        <div class="currency">FTO</div>
                    </div>
                </div>
                <div class="data-loader data-loader__block"
                     v-if="progress"></div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <p>Remember that the above calculations are valid in the current minute. The number of mined FuturoCoins is constantly changing. We can not guarantee that you will receive the FTO number listed above in that minute.</p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        dependencies: ['api', 'money', 'popup'],
        data () {
            return {
                progress        : true,
                openList        : false,
                hoverList       : false,
                packages        : {
                    100     : 1,
                    250     : 3,
                    500     : 7,
                    1000    : 15,
                    5000    : 80,
                    10000   : 180,
                    25000   : 500
                },
                selected        : 'FND 100 - 1 FORCE FACTOR',
                ftoValue        : '-'
            }
        },
        methods: {
            setItem (selected, value) {
                this.selected = selected;
                this.loadData(value);
            },

            loadData (value) {
                this.progress = true;

                this.$http.get(this.api.mining.ftoPerPowerPoint()).then(response => {
                    this.ftoValue = this.money.format(response.data.data.value * value, 'fto');
                    this.progress = false;
                }, error => {
                    this.progress = false;
                    this.popup.show('An error occurred.')
                });
            }
        },
        created () {
            this.loadData(1)
        }
    }
</script>

<style lang="scss" scoped>
    .calculator-componet{
        margin-top: 30px;
    }
    .calculator-header{
        margin-bottom: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/calculator/Calculator.vue